import React from "react";

import "../../styles/variables.scss";
import "./FeesTable.scss";

function FeesTable({ title, header, list }) {
  return (
    <div className="tp-table-container">
      {title ? (
        <div className="tp-container-header Ft-20s-20l fw600">
          <div>{title}</div>
        </div>
      ) : null}

      <div className="tp-table-body">
        <div className="tp-table-header row-spacing Ft-18s-24l fw600">
          {header.map((col) => (
            <div className="tp-table-header-column" key={col.key}>
              {col.label}
            </div>
          ))}
        </div>

        <div className="tp-table-list-wrapper">
          {list.map((row, i) => (
            <div className="list-row" key={i}>
              {header.map((col) => (
                <div className="list row-spacing Ft-18s-24l" key={col.key}>
                  {row[col.key]}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FeesTable;
